export default __webpack_public_path__ + "static/media/Monopattino2.0c7055e0.jpg";